<template>
  <label
    :id="id"
    :class="[
      ns.b(),
      ns.m(checkboxSize),
      ns.is('disabled', isDisabled),
      ns.is('checked', isChecked),
    ]"
    :aria-controls="indeterminate ? controls : null"
  >
    <span
      :class="[
        ns.e('input'),
        ns.is('disabled', isDisabled),
        ns.is('checked', isChecked),
        ns.is('indeterminate', indeterminate),
        ns.is('focus', focus),
      ]"
      :tabindex="indeterminate ? 0 : undefined"
      :role="indeterminate ? 'checkbox' : undefined"
      :aria-checked="indeterminate ? 'mixed' : false"
    >
      <input
        v-model="model"
        :class="ns.e('original')"
        type="checkbox"
        :aria-hidden="indeterminate ? 'true' : 'false'"
        v-bind="attrs"
        :disabled="isDisabled"
        :value="label"
        @change="handleChange"
        @focus="focus = true"
        @blur="focus = false"
      />
    </span>
    <span v-if="$slots.default || label" :class="ns.e('label')">
      <slot></slot>
      <template v-if="!$slots.default">{{ label }}</template>
    </span>
  </label>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'
import { useNamespace } from '@sgui-plus/hooks'
import { useCheckboxProps, useCheckbox } from './useCheckbox'

export default defineComponent({
  name: 'SgCheckbox',
  props: useCheckboxProps,
  emits: [UPDATE_MODEL_EVENT, 'on-change'],
  setup(props,{ attrs }) {
    const ns = useNamespace('checkbox')
    return {
      attrs,
      ns,
      ...useCheckbox(props),
    }
  },
})
</script>
